<template>
    <el-main class="approval-container" ref="approval-container">
        <div class="approval-content">
            <div class="search">
                <el-form :inline="true" :model="query" class="demo-form-inline">
                    <el-form-item label="公司名称">
                        <el-select v-model="query.company_id" filterable placeholder="请选择所属公司" clearable>
                            <el-option v-for="(item, index) in companyList" :key="index" :label="item.title" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="审批类型">
                        <el-select v-model="query.timing" filterable placeholder="请选择审批类型" clearable>
                            <el-option v-for="(item, index) in typeList" :key="index" :label="item.title" :value="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="doSearch">搜索</el-button>
                        <el-button type="primary" @click="resetSearch">重置</el-button>
                        <el-button type="primary" @click="showApproval('add')">添加审批规则</el-button>
                        <el-button type="primary" @click="showApprovalType()">审批类型</el-button>
                        <el-button type="danger" @click="showDeliverType()">转交</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="table-box">
                <el-table :data="tableData" style="width: 100%" v-loading="loading">
                    <el-table-column prop="id" label="编号" width="100"> </el-table-column>
                    <el-table-column prop="company" label="公司名称" width="200"> </el-table-column>
                    <el-table-column prop="timing" label="审批类型"> </el-table-column>
                    <el-table-column prop="sort" label="排序" width="160" align="center"> </el-table-column>
                    <el-table-column label="上/下线" width="160" align="center">
                        <template slot-scope="{ row }">
                            {{ row.is_valid == 1 ? '上线' : '下线' }}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center">
                        <template slot-scope="scope">
                            <el-button @click="showApproval('edit', scope.row)" type="primary" size="mini">编辑
                            </el-button>
                            <el-button @click="setApproval(scope.row)" type="primary" size="mini">配置流程</el-button>
                            <el-dropdown>
                                <el-button size="mini" type="primary" style="
                                        background-color: transparent;
                                        border-color: transparent;
                                        color: #009cff;
                                        background: transparent;
                                    ">
                                    <i class="el-icon-more"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item @click.native="deleteFn(scope.$index, scope.row)">删除
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div class="footer-box">
                <div class="download"></div>
                <div class="pagination">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagination.page" :page-sizes="[15, 30, 50, 100]" :page-size="pagination.limit" layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
                    </el-pagination>
                </div>
            </div>
        </div>

        <!-- 审批规则 -->
        <save-approval ref="saveApproval" :companyList="companyList" :typeList="typeList" @getTableData="getTableData">
        </save-approval>

        <!-- 审批类型 -->
        <save-approval-type ref="saveApprovalType" :tableData="typeList" @getTypeList="getTypeList">
        </save-approval-type>
        <save-deliver-type ref="saveDeliverType" :companyList="companyList">
        </save-deliver-type>
    </el-main>
</template>

<script>
import saveApproval from './saveApproval.vue';
import SaveApprovalType from './saveApprovalType.vue';
import saveDeliverType from './saveDeliverType.vue';
export default {
    namespaced: true,
    name: "Approval",
    components: {
        saveApproval,
        SaveApprovalType,
        saveDeliverType
    },
    data() {
        return {
            loading: false,
            query: {
                company_id: '',
                timing: ''
            },
            tableData: [],
            companyList: [],
            typeList: [],
            pagination: {
                page: 1,
                limit: 15,
                total: 0
            }
        };
    },
    created() {
        let query = localStorage.getItem("company_approval_query");
        if (query) {
            this.query = JSON.parse(query);
        }

        this.getTableData();
        this.getCompanyList();
        this.getTypeList();
    },
    methods: {
        getTableData() {
            //获取表格列表
            let that = this;
            let url = '/api/audit.audit/index';
            let query = this.query;
            query.pagination = this.pagination;
            this.loading = true;
            this.$post(url, query).then(function (response) {
                localStorage.setItem('company_approval_query', JSON.stringify(query));

                let result = response.data;
                that.tableData = result.list;
                that.pagination = result.pagination;
                that.loading = false;
            });
        },

        // 获取公司列表
        getCompanyList() {
            //获取表格列表
            let that = this;
            let url = '/api/audit.dictionary/condition';
            this.$post(url).then(function (res) {
                if (res.code == 200) {
                    let data = res.data;
                    that.companyList = data.companyList;
                }
            });
        },

        // 获取审批类型列表
        getTypeList() {
            //获取表格列表
            let that = this;
            let url = '/api/audit.category/index';
            this.$post(url).then(function (res) {
                if (res.code == 200) {
                    let data = res.data;
                    that.typeList = data.list;
                }
            });
        },

        doSearch() {
            // 搜索
            this.getTableData();
        },
        // 重置搜索项
        resetSearch() {
            this.query = {
                company_id: '',
                timing: ''
            };
            this.getTableData();
        },

        handleSizeChange(val) {
            this.pagination.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.pagination.page = val;
            this.getTableData();
        },

        // 添加审批规则
        showApproval(type, row) {
            this.$refs['saveApproval'].showDialog(type, row);
        },
        // 添加审批规则
        showDeliverType() {
            this.$refs['saveDeliverType'].showDialog();
        },
        // 添加审批规则
        showApprovalType() {
            this.$refs['saveApprovalType'].showDialog();
        },

        // 跳转配置审核流程
        setApproval(row) {
            this.$router.push({
                path: '/audit/flow/config',
                query: {
                    id: row.id
                }
            });
        },

        deleteFn(index, e) {
            let _this = this;
            this.$confirm('此操作不可撤销, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    let url = '/api/auth.role/delete';
                    let query = {
                        id: e.id
                    };
                    this.loading = true;
                    this.$post(url, query).then(function (response) {
                        if (response.code == 200) {
                            _this.tableData.splice(index, 1);
                        }
                        _this.$message({
                            type: 'success',
                            message: response.msg
                        });
                    });
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
        }
    }
};
</script>

<style lang="less">
.approval-container {
    height: 100%;
    padding: 12px;

    .approval-content {
        height: 100%;

        .search {
            margin-left: 0;
        }

        .footer-box {
            margin-top: 6px;
            display: flex;
            align-items: center;

            .download {
                flex: 0 15%;
            }

            .pagination {
                margin: 0;
                flex: 1;
            }
        }
    }
}
</style>